import { useTranslate } from '@tolgee/react';
import { useBoolean, useRequest } from 'ahooks';
import { message } from 'antd';
import { useCallback, useMemo } from 'react';
import { overseaTranslate } from 'services/api/overseaTranslate';

const useToggleShowTranslation = (
  originalText?: string,
  translatedText?: string,
  targetLang?: General.Language,
) => {
  const [showTranslation, { toggle: toggleShowTranslation }] = useBoolean(Boolean(translatedText));
  const { t } = useTranslate();
  const { data, runAsync, loading } = useRequest(
    async () => {
      if (!originalText || !targetLang) {
        return originalText;
      }
      try {
        return await overseaTranslate(originalText, targetLang, 'messageEditor');
      } catch (error) {
        message.error(t('translation.操作失败，请稍后再试'));
      }
    },
    {
      manual: true,
    },
  );
  const onToggle = useCallback(() => {
    if (!data && !translatedText) {
      runAsync().then(() => toggleShowTranslation());
      return;
    }
    toggleShowTranslation();
  }, [data, translatedText, runAsync, toggleShowTranslation]);
  const text = useMemo(() => {
    if (showTranslation) {
      return translatedText || data;
    }
    return originalText;
  }, [data, translatedText, originalText, showTranslation]);

  return {
    text,
    loading,
    onToggle,
  };
};
export default useToggleShowTranslation;
